import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

import './fonts/PTSans/PTSans-Regular.ttf';
import './fonts/PTSans/PTSans-Bold.ttf';
import './fonts/PTSans/PTSans-Italic.ttf';
import './fonts/PTSans/PTSans-BoldItalic.ttf';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
